<div class="pt-8 pb-16 px-2 md:py-[30px] md:px-[50px]">
  @if (step === 1) {
    <div>
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-houfy-color-bg.svg" alt="" />
      <img class="mx-2" src="/assets/v4/icon-link-arrow.svg" alt="" />
      <img class="w-[53px] h-[53px]" src="/assets/v4/icon-hostex-color.svg" alt="" />
    </div>

    <div class="text-l font-bold mt-[30px]">
      {{ "channel-connect_houfy_html_标题" | translate }}
    </div>

    <div class="text-m mt-[30px]">
      <div>
        {{ "channel-connect_houfy_html_描述" | translate }}
      </div>
    </div>

    <div class="text-m mt-[30px]">
      <div [innerHTML]="'channel-connect_houfy_html_注意事项' | translate"></div>
    </div>

    <div class="text-m mt-[30px]">
      <img class="hidden md:block w-full" src="https://oss.image.xiaogetech.com/ZGE1715417264330.png/xlarge" alt="" />
      <img class="w-full md:hidden" src="https://oss.image.xiaogetech.com/SZK1715417256442.png/xlarge" alt="" />
    </div>

    <div class="text-m mt-[30px]">
      <input
        type="text"
        nz-input
        nzSize="large"
        [(ngModel)]="token"
        [placeholder]="'channel-connect_houfy_html_p_token' | translate" />
    </div>

    <div [class]="footerClass">
      <button [class]="footerCancelBtnClass" nz-button nzSize="large" (click)="onCancel()">
        {{ "word.cancel" | translate }}
        <!-- Cancel -->
      </button>

      <button
        [class]="footerConfirmBtnClass"
        nz-button
        nzType="primary"
        nzSize="large"
        [nzLoading]="loading"
        (click)="onNext()">
        {{ "word.next" | translate }}
        <!-- Go to the Booking Site -->
      </button>
    </div>
  }
  <!-- @else {
    <host-set-pricing-ratio (onBack)="step = 1" (onNext)="onFinish()"></host-set-pricing-ratio>
  } -->
</div>
